import React, { Component } from 'react';
import { bool, func, string, object } from 'prop-types';

import { connect } from 'react-redux';

import EsmsDialog from '../../components/EsmsDialog';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as ClientActions from '../../actions/clientActions';
import * as SiteActions from '../../actions/siteActions';
import * as UiActions from '../../actions/uiActions';

class DeleteCampusSiteModal extends Component {
    handleDelete = async () => {
        const { deleteCampusSites, selectedClient, selectedSite, selectedNode } = this.props;

        let isDeleted;

        if (!this.props.isLoading) {
            this.props.toggleLoading(true);
            isDeleted = await deleteCampusSites(selectedNode, [selectedSite], selectedClient);
        }

        if (isDeleted) this.handleClose();
    }

    handleClose = () => {
        this.props.clearErrors();
        this.props.toggleLoading(false);
        this.props.close();
    }

    render() {
        const {
            errors,
            isLoading,
            open,
            selectedNode,
            selectedSite,
            title
        } = this.props;

        return (
            <EsmsDialog
                errors={errors}
                open={open}
                onClose={this.handleClose}
                title={title}
                onConfirm={this.handleDelete}
                isLoading={isLoading}
                confirmText="Delete"
            >
                <p>
                    Are you sure you want to remove Site: {selectedSite.name} from Campus: {selectedNode.name}?
                </p>
            </EsmsDialog>
        );
    }
}

DeleteCampusSiteModal.defaultProps = {
    selectedNode: {},
    selectedSite: {}
};

DeleteCampusSiteModal.propTypes = {
    companyInfo:  object,
    close:        func.isRequired,
    open:         bool.isRequired,
    selectedNode: object,
    selectedSite: object,
    title:        string.isRequired
};

const mapStateToProps = state => {
    return {
        errors:         state.messages.errors,
        isLoading:      state.ui.isLoading,
        selectedClient: state.client.selectedClient,
        selectedNode:   state.architect.selectedNode,
        selectedSite:   state.site.selectedSite
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...ClientActions,
    ...SiteActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteCampusSiteModal);
